export const ADD_FRAME_MATERIAL_SUCCESS = 'ADD_FRAME_MATERIAL_SUCCESS';
export const LIST_ALL_FRAME_MATERIALS_SUCCESS = 'LIST_ALL_FRAME_MATERIALS_REQUEST_SUCCESS';
export const UPDATE_FRAME_MATERIAL_SUCCESS = 'UPDATE_FRAME_MATERIAL_SUCCESS';
export const LIST_ALL_FRAME_MATERIALS_REQUEST = 'LIST_ALL_FRAME_MATERIALS_REQUEST';
export const LIST_ALL_FRAME_MATERIALS_FAILURE = 'LIST_ALL_FRAME_MATERIALS_FAILURE';
export const DELETE_FRAME_MATERIAL_SUCCESS = 'DELETE_FRAME_MATERIAL_SUCCESS';
export const CREATE_FRAME_MATERIAL_SUCCESS = 'CREATE_FRAME_MATERIAL_SUCCESS';
